import { CSSProperties } from "react";

export interface FormData {
    type: string;
    question: string;
    options: Array<string>;
    actionId: string;
    required: boolean;
    placeholder: string;
    linkTitle: string;
    linkUrl: string;
    manualInput: string | boolean;
    regexKey?: string | undefined;
    regexMessage?: string;
}

export interface FeedbackWorkflowStyleConfig {
    Form?: React.CSSProperties;
    Heading?: React.CSSProperties;
    Description?: React.CSSProperties;
    Input?: React.CSSProperties;
    Label?: React.CSSProperties;
    EmailError?: {
        text?: string;
        errorStyle?: React.CSSProperties;
    };
    TopBar?: React.CSSProperties;
    TextArea?: React.CSSProperties;
    PrimaryButton?: React.CSSProperties;
    SecondaryButton?: React.CSSProperties;
    Modal?: React.CSSProperties;
    Footer?: {
        FooterStyle?: React.CSSProperties;
        FooterTextStyle?: React.CSSProperties;
        FooterIcon?: React.CSSProperties;
        FooterText?: string
        FooterLink?: string
    };
    listHeading?: React.CSSProperties;
    listDescription?: React.CSSProperties;
    Card?: React.CSSProperties;
    Star?: {
        Style?: React.CSSProperties;
        PrimaryColor?: string;
        SecondaryColor?: string;
        Size?: number;
    };
    ScreenShot?: {
        BorderWidth?: string;
        BorderColor?: string;
        Background?: string;
        ScreenShotBackground?: string;
        CrosshairColor?: string;
    };
    listHover?: {
        background?: string;
        iconBackground?: string;
        iconColor?: string;
        Heading?: string;
        Description?: string;
        IconSize?: string;
        Icon?: React.CSSProperties;
        defaultIconBackground?: string;
    };
    ThanksPopup?: {
        Style?: React.CSSProperties;
        Heading?: React.CSSProperties;
        Description?: React.CSSProperties;
        ShowFooter?: boolean;
        Icon?: React.CSSProperties;
    };
};
export interface FeedbackWorkflowQuestThemeData {
    accentColor: string;
    theme: string;
    borderRadius: string;
    buttonColor: string;
    images: string[];
}

export interface FeedbackWorkflowBrandTheme {
    accentColor?: string;
    background?: string;
    borderRadius?: string;
    primaryButton?: string;
    secondaryButton?: string;
    contentColor?: string;
    fontFamily?: string;
    logo?: string;
    primaryColor?: string;
    secondaryColor?: string;
    tertiaryColor?: string;
    titleColor?: string;
}
export type PartialBrandTheme = Partial<FeedbackWorkflowBrandTheme>;
export type PartialQuestThemeData = Partial<FeedbackWorkflowQuestThemeData>;

export const DEFAULT_QUEST_THEME: PartialQuestThemeData = {
    accentColor: "",
    theme: "",
    borderRadius: "",
    buttonColor: "",
    images: []
};
export const DEFAULT_BRAND_THEME: PartialBrandTheme = {
    accentColor: "",
    background: "",
    borderRadius: "",
    primaryButton: "",
    contentColor: "",
    fontFamily: "",
    logo: "",
    primaryColor: "",
    secondaryColor: "",
    tertiaryColor: "",
    titleColor: ""
};

export interface FeedbackWorkflowThemeConfig {
    backgroundColor?: string;
    primaryColor?: string;
    secondaryColor?: string;
    fontFamily?: string;
}


export interface OnboardingStyleConfig {
    Form?: CSSProperties;
    Topbar?: CSSProperties;
    Heading?: CSSProperties;
    Description?: CSSProperties;
    Input?: CSSProperties;
    EmailError?: {
        text?: string;
        errorStyle?: CSSProperties;
    };
    TextError?: {
        text?: string;
        errorStyle?: CSSProperties;
    };
    NumberError?: {
        text?: string;
        errorStyle?: CSSProperties;
    };
    TextAreaError?: {
        text?: string;
        errorStyle?: CSSProperties;
    };
    Label?: CSSProperties;
    TextArea?: CSSProperties;
    PrimaryButton?: CSSProperties;
    SecondaryButton?: CSSProperties;
    SingleChoice?: {
        style?: CSSProperties;
        selectedStyle?: CSSProperties;
        hoverBackground?: string
    };
    MultiChoice?: {
        style?: CSSProperties;
        selectedStyle?: CSSProperties;
        isLabel?: boolean;
    };
    ProgressBar?: {
        completeTabColor?: string;
        currentTabColor?: string;
        pendingTabColor?: string;
    };

    Footer?: {
        FooterStyle?: CSSProperties;
        FooterTextStyle?: CSSProperties;
        FooterIcon?: CSSProperties;
        FooterText?: string;
        FooterLink?: string;
    };
};